import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EnvService {
    public API_URL = '';
    public DOMAIN = '';
    public FILE_URL = '';
    public WS_DISABLED = false;
    public WS_BASE_URL = '';
    public WS_NOTIFICATION_PATH = '';
    public WS_RECONNECT_DELAY_MS = 10000;
    public WS_STOMP_HEARTBEAT_MS = 10000;
    public KEYCLOAK_URL = '';
    public KEYCLOAK_REALM = '';
    public KEYCLOAK_CLIENT_ID = '';
    /** HPC is available by default; set false to disable it. */
    public HPC_ENABLED = true;
    /** HPC system opened after buying a package ("Truy cập hpc.datacore.vn"). */
    public HPC_URL = 'https://hpc.datacore.vn';
    public PUBLIC_KEY = '';
    public PRIVATE_KEY = '';
    public enableDebug = false;
}
